var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.61 14C15.5557 13.8785 15.4813 13.7669 15.39 13.67L10.76 9C10.5687 8.83617 10.3226 8.75057 10.071 8.76029C9.81929 8.77001 9.58055 8.87434 9.40246 9.05244C9.22436 9.23053 9.12003 9.46927 9.11031 9.72095C9.10059 9.97262 9.18619 10.2187 9.35002 10.41L12.27 13.33H5.27002C4.47437 13.33 3.71131 13.0139 3.1487 12.4513C2.58609 11.8887 2.27002 11.1256 2.27002 10.33V1C2.27002 0.734784 2.16466 0.48043 1.97713 0.292893C1.78959 0.105357 1.53524 0 1.27002 0C1.0048 0 0.750449 0.105357 0.562913 0.292893C0.375377 0.48043 0.27002 0.734784 0.27002 1V10.37C0.27002 11.6961 0.796804 12.9679 1.73449 13.9055C2.67217 14.8432 3.94394 15.37 5.27002 15.37H12.27L9.35002 18.29C9.25629 18.383 9.1819 18.4936 9.13113 18.6154C9.08036 18.7373 9.05422 18.868 9.05422 19C9.05422 19.132 9.08036 19.2627 9.13113 19.3846C9.1819 19.5064 9.25629 19.617 9.35002 19.71C9.44346 19.8027 9.55428 19.876 9.67611 19.9258C9.79795 19.9755 9.92841 20.0008 10.06 20C10.3224 19.9989 10.5738 19.8947 10.76 19.71L15.39 15.08C15.4846 14.9858 15.5595 14.8736 15.61 14.75C15.7073 14.5095 15.7073 14.2405 15.61 14Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnDownRight);
export default __webpack_public_path__ + "static/media/turn_down_right.dd0ef6eeebfcd4c73ecbe83bd0dce3c9.svg";
export { ForwardRef as ReactComponent };